module.exports = __webpack_public_path__ + "static/media/TheIslandsofElsewhere.9ac5c0d1.jpg";